import { fizz as fizzConfig } from "@max/thirdparty/companies/fizz";
import { GtbAffiliationMap } from "@max/common/dist/thirdparty/gtb";

import { UserMenuOptions } from "../gtb/Components/UserMenuOptions";
import { GtbCustomApp } from "../gtb/types";
import { gtb } from "../gtb";

export const fizz: GtbCustomApp = {
  ...fizzConfig,
  routes: gtb.routes,
  UserMenuOptions,
  userRoles: JSON.parse(
    JSON.stringify(GtbAffiliationMap).replaceAll("GTB", "Fizz"),
  ),
};
